'use strict';

var $ = require('jquery');

function init() {
	var $moreLess = $('a.expandableLink');

	$moreLess.each(function(){
		var $this = $(this),
			$extendedContent = $this.parent().find('.expandableContent');
		
		$this.data('opened', false);
		
		$this.on('click', function(){
			$this.toggleClass('expandableLink--open');
			
			if ( $this.data('opened') == false ) {
				$extendedContent.slideDown(200, 'easeOutCirc');
				$this.html($this.data('close-text'));
				$this.data('opened', true);
			} else {
				$extendedContent.slideUp(200, 'easeInCirc');
				$this.html($this.data('open-text'));
				$this.data('opened', false);
			}
			return false;
		});
	});
}
module.exports = {
	init : init
};